/* global GLightbox */

/**
 * @file
 * GLightbox functionality.
 */

((Drupal, once) => {
  /**
   * Initialize glightbox.
   */
  function init() {
    const _selector = '[data-glightbox]';

    GLightbox({
      selector: _selector,
      touchNavigation: true,
    });
  }

  Drupal.behaviors.glightbox = {
    attach(context) {
      const _$lightbox = once('glightbox', '[data-glightbox]', context).shift();

      // If there is a lightbox.
      if (_$lightbox) {
        init();
      }
    }
  };
})(Drupal, once);
